
import { Team } from "../team/team.model";

export class ProgramTeamAccount {
    programTeamAccountID: number;
    teamAccountID: number;
    programID: number;
    program: ProgramLite;
    teamAccount: TeamAccount;
    showBudgetToParents: boolean;
    isDeleted: boolean;
}

export class TeamAccount {
    teamAccountID: number;
    teamID: number;
    team: Team;
    isDeleted: boolean;
    provisioningStatusID: number;
    programTeamAccounts: ProgramTeamAccount[];
}

export class ProgramLite {
    programID: number;
    name: string;
    programTypeID: number;
    parentProgramID?: number;
    clubProgramCategoryID?: number;
    startDate?: Date;
    endDate?: Date;
    isAdultProgram: boolean;
}

export interface ClubUserTeamAccount {
    teamAccountID: number;
    programTeamAccountID: number;
    teamName: string;
    teamID: number;
    programID: number;
    programName: string;
    programTeamAccountUserRoleID: number;
    roleDescription: string;
    teamColorOptionID: number;
    // Derived from programTeamAccountUserRoleID — set after API response, not part of the API contract
    isTreasurer?: boolean;
    isCardholder?: boolean;
}

export enum ManageTeamAccountView {
    ADMIN = 1,
    MANAGER = 2,
    MEMBER = 3
}

export interface FinancialAccountRoutingInfo {
    accountName: string;
    accountNumber: string;
    routingNumber: string;
}